import { palette } from "./tokens";

/**
 * The mark: two solid fields meeting at a hard edge, OR on the seam.
 *
 * It is the mechanic — the same split a player taps on every turn — so the
 * logo teaches the game before a word is read, and the OR reads as the hinge
 * between the two rather than a label on top.
 *
 * 1:1 by construction, so one piece of artwork serves as logo and favicon.
 * `textLength` with `lengthAdjust="spacingAndGlyphs"` pins BAD to the full
 * width, so it fills the square exactly rather than by a hand-tuned font size.
 *
 * Space Grotesk throughout, badge included — plan.md §2.3 allows one family.
 */

const FAMILY = "'Space Grotesk Variable', system-ui, sans-serif";

export const Logo = ({
  size = 128,
  /** Off below ~24px, where the badge is a couple of pixels tall and muddies. */
  badge = true,
  rounded = 0,
  title = "Bad or Bad",
}: {
  size?: number;
  badge?: boolean;
  rounded?: number;
  title?: string;
}) => {
  const clip = `logo-clip-${size}-${badge ? 1 : 0}-${rounded}`;

  return (
    <svg width={size} height={size} viewBox="0 0 100 100" role="img" aria-label={title}>
      <defs>
        <clipPath id={clip}>
          <rect width="100" height="100" rx={rounded} />
        </clipPath>
      </defs>

      <g clipPath={`url(#${clip})`}>
        <rect width="100" height="50" fill={palette.sideA} />
        <rect y="50" width="100" height="50" fill={palette.sideB} />

        <text
          x="50"
          y="25"
          textAnchor="middle"
          dominantBaseline="central"
          textLength="94"
          lengthAdjust="spacingAndGlyphs"
          fontSize="40"
          fontWeight="700"
          fill={palette.bg}
          style={{ fontFamily: FAMILY }}
        >
          BAD
        </text>
        <text
          x="50"
          y="75"
          textAnchor="middle"
          dominantBaseline="central"
          textLength="94"
          lengthAdjust="spacingAndGlyphs"
          fontSize="40"
          fontWeight="700"
          fill={palette.ink}
          style={{ fontFamily: FAMILY }}
        >
          BAD
        </text>

        {badge && (
          <g transform="rotate(-8 50 50)">
            <rect x="34" y="43" width="32" height="14" rx="7" fill={palette.ink} />
            <text
              x="50"
              y="50.5"
              textAnchor="middle"
              dominantBaseline="central"
              fontSize="8"
              fontWeight="700"
              letterSpacing="1.4"
              fill={palette.bg}
              style={{ fontFamily: FAMILY }}
            >
              OR
            </text>
          </g>
        )}
      </g>
    </svg>
  );
};
